<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <form name="unlockForm" novalidate class="form-info">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="exp-message">Email Sent!</p>

            <ul class="form-grid">
              <li class="password-hint">
                <p class="email-sent">An email has been sent to
                  <span class="email-address-name">{{emailAddress}}</span>
                  with instructions on {{operationMessage}}.</p>
              </li>
              <li>
                <div class="okta-action-buttons">
                  <button id="btn-cancel" type="submit" mat-raised-button color="accent" (click)="onCancelClick()">Back To Home</button>
                </div>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>